import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = {
  key: 0,
  class: "text-medium-emphasis"
}
const _hoisted_3 = {
  key: 2,
  class: "text-error mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _ctx.onClose,
    "max-width": "600"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode("Share \"" + _toDisplayString(_ctx.agentName) + "\"", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.recipient,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.recipient) = $event)),
                label: "Username or Email",
                disabled: _ctx.loading,
                onKeyup: _withKeys(_ctx.addShare, ["enter"]),
                clearable: ""
              }, null, 8, ["modelValue", "disabled", "onKeyup"]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_checkbox, {
                  modelValue: _ctx.editable,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editable) = $event)),
                  label: "Allow editing",
                  "hide-details": "",
                  density: "compact",
                  disabled: _ctx.loading,
                  class: "mr-3 my-0 py-0 flex-grow-0"
                }, null, 8, ["modelValue", "disabled"]),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  disabled: _ctx.loading || !_ctx.recipient.trim(),
                  onClick: _ctx.addShare
                }, {
                  default: _withCtx(() => [
                    (_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 0,
                          indeterminate: "",
                          size: "16",
                          width: "2",
                          color: "white",
                          class: "mr-2"
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(_ctx.loading ? 'Sharing...' : 'Share'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _createVNode(_component_v_divider, { class: "my-4" }),
              (_ctx.shares.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, "No recipients yet."))
                : (_openBlock(), _createBlock(_component_v_list, {
                    key: 1,
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shares, (s, i) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: i,
                          title: `${s.recipientType}: ${s.recipient}`,
                          subtitle: new Date(s.createdAt).toLocaleString()
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_v_switch, {
                              "model-value": s.editable,
                              "onUpdate:modelValue": (v) => _ctx.setEditable(s, v === true),
                              label: "Editable",
                              color: "primary",
                              "hide-details": "",
                              density: "compact",
                              disabled: _ctx.loading,
                              class: "mr-2 my-0 py-0"
                            }, null, 8, ["model-value", "onUpdate:modelValue", "disabled"]),
                            _createVNode(_component_v_btn, {
                              icon: "mdi-delete-outline",
                              variant: "text",
                              onClick: ($event: any) => (_ctx.revoke(s)),
                              disabled: _ctx.loading,
                              "aria-label": `Revoke ${s.recipientType} ${s.recipient}`
                            }, null, 8, ["onClick", "disabled", "aria-label"])
                          ]),
                          _: 2
                        }, 1032, ["title", "subtitle"]))
                      }), 128))
                    ]),
                    _: 1
                  })),
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.error), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClose(false)))
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("Close")
                ])),
                _: 1,
                __: [3]
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue"]))
}